module.exports = __webpack_public_path__ + "img/ico-file-blue.0935f320.svg";